import { useEffect, useState } from "react";
import { Brand } from "./Brand";

const navigation = [
  { href: "/", label: "AIYSSとは", english: "TOP" },
  { href: "/league/", label: "年間リーグ", english: "LEAGUE" },
  { href: "/job-quest/", label: "Job Quest", english: "QUEST" },
  { href: "/activities/", label: "活動内容", english: "ACTIVITIES" },
  { href: "/members/", label: "メンバー", english: "MEMBERS" },
  { href: "/articles/", label: "活動報告記事", english: "ARTICLES" },
  { href: "/sponsors/", label: "スポンサー", english: "SPONSORS" },
  {
    href: "/contact/",
    label: "お問い合わせ",
    english: "CONTACT",
    mobileOnly: true,
  },
];

function isCurrentNavigationItem(href: string, pathname: string) {
  const normalizedPathname = pathname.replace(/\/+$/, "") || "/";
  const normalizedHref = href.replace(/\/+$/, "") || "/";

  if (normalizedHref === "/") {
    return normalizedPathname === "/";
  }

  return (
    normalizedPathname === normalizedHref ||
    normalizedPathname.startsWith(`${normalizedHref}/`)
  );
}

export function Header() {
  const [isOpen, setIsOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const pathname = window.location.pathname;

  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 24);
    handleScroll();
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const closeMenu = () => setIsOpen(false);

  return (
    <header className={`site-header${isScrolled ? " is-scrolled" : ""}`}>
      <div className="header-inner">
        <Brand />

        <button
          className={`menu-toggle${isOpen ? " is-open" : ""}`}
          type="button"
          aria-expanded={isOpen}
          aria-controls="primary-nav"
          onClick={() => setIsOpen((open) => !open)}
        >
          <span />
          <span />
          <span className="sr-only">メニューを開く</span>
        </button>

        <nav
          className={`primary-nav${isOpen ? " is-open" : ""}`}
          id="primary-nav"
          aria-label="メインナビゲーション"
        >
          {navigation.map((item) => {
            const isCurrent = isCurrentNavigationItem(item.href, pathname);

            return (
              <a
                key={item.href}
                href={item.href}
                className={item.mobileOnly ? "mobile-nav-only" : undefined}
                aria-current={isCurrent ? "page" : undefined}
                onClick={closeMenu}
              >
                <span>{item.english}</span>
                {item.label}
              </a>
            );
          })}
        </nav>

        <div className="header-actions">
          <a
            href="/contact/"
            aria-current={
              isCurrentNavigationItem("/contact/", pathname)
                ? "page"
                : undefined
            }
          >
            お問い合わせ
          </a>
          <a className="header-apply" href="/sponsors/">
            スポンサー企業の方へ <span aria-hidden="true">→</span>
          </a>
        </div>
      </div>
    </header>
  );
}
